import tokens from 'config/constants/tokens'

export const DEFAULT_INPUT_CURRENCY = tokens.cro.symbol
export const DEFAULT_OUTPUT_CURRENCY = tokens.usdc.address
